<template>
    <div class="qksm">
        <div class="nogap">
            <h4>（三）2021年采购预算安排及执行情况</h4>
            <p>2021年安排政府采购预算{{isMoney(T3.预算)}}万元，截止2021年9月30日，实际执行{{isMoney(T3.执行)}}万元（详见附表三）。</p>
        </div>
    </div>
</template>
<script>
    export default {
        name: "qksm3Last",
        data() {
            return {
                isPdf: this.$parent.isPdf,
                qksm: this.$store.state.divData.qksm,
            }
        },
        props: {
            T3: {
                type: Object,
                default: "",
            },
        },
    };
</script>